import { render, staticRenderFns } from "./TeacherWeekChart.vue?vue&type=template&id=8791b7ec&scoped=true"
import script from "./TeacherWeekChart.vue?vue&type=script&lang=js"
export * from "./TeacherWeekChart.vue?vue&type=script&lang=js"
import style0 from "./TeacherWeekChart.vue?vue&type=style&index=0&id=8791b7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8791b7ec",
  null
  
)

export default component.exports